export default function ToolTip(theme) {
    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    // 1. Background Color
                    backgroundColor: theme.palette.primary.darker,
                    fontSize: 12,
                    fontWeight: 400,
                    fontFamily: 'inter',
                    color: theme.palette.grey[0],
                    border: theme.palette.primary.darke,
                },
                arrow: {
                    color: theme.palette.primary.darker,
                },
            },
        },
    };
}